(function () {
  const fields = [
    'attributes[PO]',
    'attributes[VAT]',
    'attributes[EORI]'
  ];

  function restoreFields() {
    fields.forEach(name => {
      const el = document.querySelector(`[name="${name}"]`);
      if (!el) return;

      const value = localStorage.getItem('bss_' + name);
      if (value !== null) {
        el.value = value;
      }
    });
  }

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.name) return;

    if (fields.includes(e.target.name)) {
      localStorage.setItem('bss_' + e.target.name, e.target.value);
    }
  });

  restoreFields();

  document.addEventListener('bss_b2b:CustomCartUpdate', function () {
    setTimeout(restoreFields, 50);
  });
})();

document.addEventListener("DOMContentLoaded", e => {
  const po = document.querySelector("#bss-cart-note-textarea");
  if(po) {
    po.value = '';
  }
});

  ;(function() {
    var checkExist = setInterval(function() {
       var installmentForm = document.getElementById('product-form-installment');
       if (installmentForm) {
          installmentForm.remove(); // Xóa hẳn phần tử khỏi trang
          clearInterval(checkExist);
       }
    }, 100); // Kiểm tra mỗi 0.1 giây cho đến khi tìm thấy và xóa
    setTimeout(() => clearInterval(checkExist), 10000);
  })();

// SBCB2BBS-5281: synchronise BSS CP/PL with Taxify, using its current VAT rule/formatter.
;(() => {
  if (window.Shopify?.theme?.schema_name !== 'Athens' || window.__bssTaxify5281) return;
  window.__bssTaxify5281 = true;
  const selector = '.price-container[bss-b2b-variant-price]';
  const records = new WeakMap();
  let frame = 0;

  function remember(element, cents) {
    if (!element?.matches(selector) || element.closest('.taxify-price-container')) return;
    if (!Number.isFinite(cents) || cents < 0) return;
    const original = element.closest('.price');
    if (!original || original.classList.contains('taxify-price-container')) return;
    const old = records.get(element);
    // Taxify's parser checks data-price before HTML; it must not parse a crossed-out retail price.
    // Integer strings are Shopify money subunits, as expected by the live Taxify parser.
    original.setAttribute('data-price', String(Math.round(cents)));
    records.set(element, { ...old, cents, original });
    schedule();
  }

  const tag = 'custom:product_page/cp_pl_show_price';
  const hooks = window.bssB2BHooks ||= { actions: {}, filters: {} };
  hooks.filters ||= {};
  const previous = hooks.filters[tag];
  const filter = (html, context) => {
    const result = typeof previous === 'function' ? previous(html, context) : html;
    remember(context?.priceElement, context?.cpPrices?.price ?? context?.plPrices?.price);
    return result;
  };
  if (window.BSS_B2B?.addFilter) window.BSS_B2B.addFilter(tag, filter);
  else hooks.filters[tag] = filter;

  function sync(element) {
    const record = records.get(element);
    const taxify = window.Taxify;
    if (!record || !element.isConnected || !taxify?.currentRule || !taxify.processElement || !taxify.replacer?.restore) return;
    const original = record.original;
    const output = original.nextElementSibling?.classList.contains('taxify-price-container')
      ? original.nextElementSibling : null;
    const signature = `${record.cents}|${taxify.currentRule.id}|${taxify.currentRule.displayMode}`;
    if (record.signature === signature && record.output === output && (output || record.cents === 0)) return;
    if (output) taxify.replacer.restore(output);
    original.classList.remove('taxify-original-hidden');
    original.removeAttribute('aria-hidden');
    original.removeAttribute('data-taxify-processed');
    taxify.processedElements?.delete(original);
    // Its parser ignores zero. Keep BSS's valid free-price HTML visible in that case.
    if (record.cents > 0) taxify.processElement(original);
    record.signature = signature;
    record.output = original.nextElementSibling?.classList.contains('taxify-price-container')
      ? original.nextElementSibling : null;
  }

  function currentPrice(element) {
    const variant = window.BSS_B2B?.storage?.variantStorage?.get(Number(element.getAttribute('bss-b2b-variant-id')));
    if (variant?.bssB2bShowPriceKey === 'pl') return variant.bssB2BPriceAfterPL;
    if (variant?.bssB2bShowPriceKey === 'cp') return variant.bssB2BPriceAfterCP;
  }

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      document.querySelectorAll(selector).forEach((element) => {
        if (!records.has(element)) {
          // Covers an asset loaded after BSS has already rendered its initial price.
          const cents = currentPrice(element);
          if (Number.isFinite(cents)) {
            const original = element.closest('.price');
            if (original && !original.classList.contains('taxify-price-container')) {
              original.setAttribute('data-price', String(Math.round(cents)));
              records.set(element, { cents, original });
            }
          }
        }
        try { sync(element); }
        catch (error) { console.warn('[BSS Taxify sync]', error); }
      });
    });
  }

  function start() {
    const pending = new Set();
    let renderFrame = 0;
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1 || node.closest('.taxify-price-container')) continue;
          const elements = node.matches(selector) ? [node] : node.querySelectorAll(selector);
          for (const element of elements) {
            if (!element.hasAttribute('bss-b2b-product-active')) pending.add(element);
          }
        }
      }
      if (pending.size && !renderFrame) {
        renderFrame = requestAnimationFrame(() => {
          renderFrame = 0;
          const subject = window.BSS_B2B?.observer?.productSubject;
          const forms = new Set();
          pending.forEach((element) => {
            if (!element.isConnected || element.hasAttribute('bss-b2b-product-active')) return;
            const form = element.closest('[bss-b2b-product-form-id]')
              || document.querySelector('[bss-b2b-main-product-form]');
            if (form) forms.add(form);
          });
          pending.clear();
          forms.forEach((productForm) => subject?.notifyObserver('VariantChange', 'VariantSelectChange', { productForm }));
        });
      }
      // Also catches Taxify initialisation, VAT toggles and targeted/full rescans.
      schedule();
    }).observe(document.body, { subtree: true, childList: true });
    schedule();
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
